import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../../../../../components/Footer/Footer";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import "./ShadBhav.scss";
import { useFormData } from "../../ContextData/ContextData";


const ShadBhav = () => {
  const { userData } = useFormData();
  const [shadBalaData, setShadBalaData] = useState(null);
  const [bhavBalaData, setBhavBalaData] = useState(null);
  const [loading, setLoading] = useState(true);

  const planets = ["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn"];
  const houses = [1,2,3,4,5,6,7,8,9,10,11,12];

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch Shad Bala
        const shadRes = await axios.get(
          "https://core-c343.onrender.com/api/shadbala",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
              location: userData.city,
            },
          }
        );

        // Transform Shad Bala data
        const shad = shadRes.data.shadBala;
        const shadTransformed = Object.entries(shad).map(([type, values]) => ({
          type,
          ...values,
        }));

        // Fetch Bhav Bala
        const bhavRes = await axios.get(
          "https://core-c343.onrender.com/api/bhavbala",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
              location: userData.city,
            },
          }
        );

        // Transform Bhav Bala data
        const bhav = bhavRes.data.bhavBala;
        const bhavTransformed = Object.entries(bhav).map(([type, values]) => ({
          type,
          ...values,
        }));

        setShadBalaData(shadTransformed);
        setBhavBalaData(bhavTransformed);
      } catch (error) {
        console.error("Error fetching Shad/Bhav Bala data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p className="loading">Loading Shad Bala & Bhav Bala data...</p>;
  if (!shadBalaData || !bhavBalaData) return <p className="error">Failed to load data.</p>;

  return (
    <div className="shadbhav-container">
      <InnerNav />
      <div className="shadbhav-content">
        <h1>Shad Bala & Bhav Bala Tables</h1>

        {/* Shad Bala Table */}
        <h2>Shad Bala Tables</h2>
        <div className="shadbhav-table">
          <table>
            <thead>
              <tr>
                <th></th>
                {planets.map((planet) => (
                  <th key={planet}>{planet}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {shadBalaData.map((row, i) => (
                <tr key={i}>
                  <th>{row.type}</th>
                  {planets.map((planet) => (
                    <td key={planet}>{row[planet]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Bhav Bala Table */}
        <h2>Bhav Bala Tables</h2>
        <div className="shadbhav-table">
          <table>
            <thead>
              <tr>
                <th></th>
                {houses.map((house) => (
                  <th key={house}>{house}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {bhavBalaData.map((row, i) => (
                <tr key={i}>
                  <th>{row.type}</th>
                  {houses.map((house) => (
                    <td key={house}>{row[house]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShadBhav;
